import { render } from "./ProfileEdit.vue?vue&type=template&id=2aae5a24&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"

import "./ProfileEdit.vue?vue&type=style&index=0&id=2aae5a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aae5a24"]])

export default __exports__